import i18next from "i18next";
import React, { useEffect, useState } from "react";
import DocViewerCard from "../../components/doc-viewer/DocViewerCard";
import DocViewerTable from "../../components/doc-viewer/DocViewerTable";
import DocViewerFromJson from "components/doc-viewer/DocViewerFromJson";

function PanelExtractedData({documentCode, contents, extractorResults}) {
    const [cardTitle, setCardTitle] = useState();
    const [cardBody,] = useState();

    useEffect(() => {
        let cardTitle = i18next.t('viewer.extractedContent.title');
        // let extractDate;
        if(extractorResults) {
            setCardTitle([cardTitle, i18next.t("viewer.extractor.title")])
        } else {
            setCardTitle([cardTitle, i18next.t("viewer.notAnalyzed")])
        }
    }, [documentCode, contents, extractorResults]);

    return (
        <DocViewerCard
            title={null}
            body={
                extractorResults ?
                <DocViewerFromJson
                    header={cardTitle}
                    body={extractorResults}
                    hideFirstLevelKey={true}
                    hideSecondLevelKey={true}
                    keysToExclude={['decision', 'isValid']}
                    translationPrefix='viewer.extractor'
                    translateValuesForKeys={['insuranceType']}
                    openRowsOnLoad={true}
                    /> 
                    :
                <DocViewerTable
                        {...(cardBody?.length > 0 ?
                        {
                            body: cardBody
                        }
                        : {})
                    }
                    />
            }
            
        />
    );
}

export default PanelExtractedData;
